"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSums = exports.getDepositShareSums = exports.getBillingSums = exports.organizeBilling = exports.getBillingVoucherIdsFromDepositShare = exports.DepositShareType = void 0;
const billing_vouchers_1 = require("../billing-vouchers");
const vouchers_1 = require("../vouchers");
var DepositShareType;
(function (DepositShareType) {
    DepositShareType["AdjustmentDebit"] = "ADJUSTMENT_DEBIT";
    DepositShareType["AdjustmentCredit"] = "ADJUSTMENT_CREDIT";
    DepositShareType["Deposit"] = "DEPOSIT";
})(DepositShareType || (exports.DepositShareType = DepositShareType = {}));
const isDepositShare = (billingVoucher) => billingVoucher.depositCaseVoucherId &&
    ![vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT].includes(billingVoucher.voucherTypeId);
const getBillingVoucherIdsFromDepositShare = (depositShare) => {
    let billingVoucherIds = [];
    billingVoucherIds = billingVoucherIds.concat(depositShare.overpayments.map((v) => v.billingVoucherId));
    billingVoucherIds = billingVoucherIds.concat(depositShare.vat.map((v) => v.billingVoucherId));
    billingVoucherIds = billingVoucherIds.concat(depositShare.share
        .map((share) => {
        let shareBillingVoucherIds = [];
        shareBillingVoucherIds = shareBillingVoucherIds.concat(share.vatVouchers.map((billingVoucher) => billingVoucher.billingVoucherId));
        shareBillingVoucherIds = shareBillingVoucherIds.concat(share.collectionCommissionVouchers.map((billingVoucher) => billingVoucher.billingVoucherId));
        shareBillingVoucherIds = shareBillingVoucherIds.concat(share.payoutVouchers.map((billingVoucher) => billingVoucher.billingVoucherId));
        return shareBillingVoucherIds;
    })
        .reduce((acc, arr) => acc.concat(arr), []));
    return billingVoucherIds.filter((id, i) => billingVoucherIds.indexOf(id) === i);
};
exports.getBillingVoucherIdsFromDepositShare = getBillingVoucherIdsFromDepositShare;
const organizeBilling = (billingVouchers) => {
    let depositShareMap = {};
    let organizedBillingVouchers = {};
    for (let i = 0; i < billingVouchers.length; i++) {
        const billingVoucher = billingVouchers[i];
        if (isDepositShare(billingVoucher) &&
            billingVoucher.category !== vouchers_1.VoucherCategory.VAT) {
            const { _depositShareMap, _organizedBillingVouchers } = append(depositShareMap, organizedBillingVouchers, billingVoucher);
            organizedBillingVouchers = Object.assign(Object.assign({}, organizedBillingVouchers), _organizedBillingVouchers);
            depositShareMap = _depositShareMap;
        }
    }
    for (let i = 0; i < billingVouchers.length; i++) {
        const billingVoucher = billingVouchers[i];
        if (billingVoucher.category === vouchers_1.VoucherCategory.VAT) {
            const vatOfCollectionCommissionBillingVoucher = billingVouchers.find((_billingVoucher) => _billingVoucher.category === vouchers_1.VoucherCategory.COLLECTIONCOMMISSION &&
                _billingVoucher.billingVoucherId ===
                    billingVoucher.vatOfBillingVoucherId);
            if (vatOfCollectionCommissionBillingVoucher &&
                vatOfCollectionCommissionBillingVoucher.depositCaseVoucherId &&
                vatOfCollectionCommissionBillingVoucher.caseVoucherId &&
                depositShareMap[genDepositShareKey(vatOfCollectionCommissionBillingVoucher)].share[vatOfCollectionCommissionBillingVoucher.caseVoucherId]) {
                organizedBillingVouchers[billingVoucher.billingVoucherId] = true;
                depositShareMap[genDepositShareKey(vatOfCollectionCommissionBillingVoucher)].vat =
                    depositShareMap[genDepositShareKey(vatOfCollectionCommissionBillingVoucher)].vat.concat(billingVoucher);
            }
        }
    }
    const disbursements = billingVouchers
        .filter((voucher) => voucher.category === vouchers_1.VoucherCategory.DISBURSEMENT)
        .map((v) => {
        const vat = billingVouchers.filter((vs) => vs.vatOfBillingVoucherId === v.billingVoucherId &&
            vs.category === vouchers_1.VoucherCategory.VAT);
        vat.map((vos) => {
            organizedBillingVouchers[vos.billingVoucherId] = true;
        });
        return Object.assign(Object.assign({}, v), { vat });
    });
    disbursements.map((v) => {
        organizedBillingVouchers[v.billingVoucherId] = true;
    });
    const fees = billingVouchers
        .filter((billingVoucher) => billingVoucher.category === vouchers_1.VoucherCategory.FEE &&
        !organizedBillingVouchers[billingVoucher.billingVoucherId])
        .map((v) => {
        const vat = billingVouchers.filter((vs) => vs.vatOfBillingVoucherId === v.billingVoucherId &&
            vs.category === vouchers_1.VoucherCategory.VAT);
        vat.map((vos) => {
            organizedBillingVouchers[vos.billingVoucherId] = true;
        });
        return Object.assign(Object.assign({}, v), { vat });
    });
    fees.map((v) => {
        organizedBillingVouchers[v.billingVoucherId] = true;
    });
    const vat = billingVouchers.filter((voucher) => voucher.category === vouchers_1.VoucherCategory.VAT &&
        !organizedBillingVouchers[voucher.billingVoucherId]);
    vat.map((v) => {
        organizedBillingVouchers[v.billingVoucherId] = true;
    });
    const notOrganizedBillingVouchers = billingVouchers.filter((v) => !organizedBillingVouchers[v.billingVoucherId]);
    return {
        depositShare: Object.values(depositShareMap).map((depositShare) => ({
            caseId: depositShare.caseId,
            deposit: depositShare.deposit,
            info: depositShare.info,
            overpayments: depositShare.overpayments,
            vat: depositShare.vat,
            share: Object.values(depositShare.share),
            type: depositShare.type,
        })),
        notOrganizedBillingVouchers,
        disbursements,
        fees,
        vat,
    };
};
exports.organizeBilling = organizeBilling;
const genDepositShareKey = (billingVoucher) => `${billingVoucher.depositCaseVoucherId}${billingVoucher.isAdjustment
    ? `-adjustment-${billingVoucher.amount > 0 ? 'credit' : 'debit'}`
    : ''}`;
const append = (depositShareMap, organizedBillingVouchers, billingVoucher) => {
    if (!billingVoucher.depositCaseVoucherId ||
        (!billingVoucher.caseVoucherId &&
            billingVoucher.category !== vouchers_1.VoucherCategory.OVERPAYMENT)) {
        return {
            _organizedBillingVouchers: organizedBillingVouchers,
            _depositShareMap: depositShareMap,
        };
    }
    organizedBillingVouchers[billingVoucher.billingVoucherId] = true;
    const key = genDepositShareKey(billingVoucher);
    if (!depositShareMap[key]) {
        depositShareMap[key] = {
            caseId: billingVoucher.caseId,
            deposit: billingVoucher.depositCaseVoucher || null,
            info: billingVoucher.info,
            overpayments: [],
            share: {},
            vat: [],
            type: billingVoucher.isAdjustment
                ? billingVoucher.amount < 0
                    ? DepositShareType.AdjustmentCredit
                    : DepositShareType.AdjustmentDebit
                : DepositShareType.Deposit,
        };
    }
    if (billingVoucher.caseVoucherId &&
        !depositShareMap[key].share[billingVoucher.caseVoucherId]) {
        depositShareMap[key].share[billingVoucher.caseVoucherId] = {
            caseVoucher: billingVoucher.caseVoucher || null,
            collectionCommissionBalance: 0,
            collectionCommissionVouchers: [],
            payoutBalance: 0,
            payoutVouchers: [],
            vatBalance: 0,
            vatVouchers: [],
        };
    }
    if (billingVoucher.caseVoucherId &&
        billingVoucher.category === vouchers_1.VoucherCategory.COLLECTIONCOMMISSION) {
        depositShareMap[key].share[billingVoucher.caseVoucherId].collectionCommissionVouchers =
            depositShareMap[key].share[billingVoucher.caseVoucherId].collectionCommissionVouchers.concat(billingVoucher);
        depositShareMap[key].share[billingVoucher.caseVoucherId].collectionCommissionBalance += billingVoucher.amount;
    }
    else if (billingVoucher.caseVoucherId &&
        billingVoucher.category === vouchers_1.VoucherCategory.PAYOUT) {
        depositShareMap[key].share[billingVoucher.caseVoucherId].payoutVouchers =
            depositShareMap[key].share[billingVoucher.caseVoucherId].payoutVouchers.concat(billingVoucher);
        depositShareMap[key].share[billingVoucher.caseVoucherId].payoutBalance +=
            billingVoucher.amount;
    }
    else if (billingVoucher.category === vouchers_1.VoucherCategory.OVERPAYMENT) {
        depositShareMap[key].overpayments =
            depositShareMap[key].overpayments.concat(billingVoucher);
    }
    else {
        console.error(billingVoucher);
        throw new Error('Error: Billing voucher not handled correctly');
    }
    return {
        _organizedBillingVouchers: organizedBillingVouchers,
        _depositShareMap: depositShareMap,
    };
};
const getVatSum = (vouchers) => vouchers.reduce((acc, voucher) => acc + voucher.vat.reduce((azz, vat) => azz + vat.amount, 0), 0);
const getBillingSums = (billing) => {
    return {
        balance: -billing.payout + billing.vat + billing.disbursements + billing.revenue,
    };
};
exports.getBillingSums = getBillingSums;
const getDepositShareSums = (depositShare) => {
    const deposit = depositShare.share.reduce((azz, s) => {
        return s.payoutBalance + s.collectionCommissionBalance + azz;
    }, 0);
    const collectionCommission = depositShare.share.reduce((azz, s) => {
        return s.collectionCommissionBalance + azz;
    }, 0);
    const payout = depositShare.share.reduce((azz, s) => {
        return s.payoutBalance + azz;
    }, 0);
    const overpayment = (0, billing_vouchers_1.billingVoucherSum)(depositShare.overpayments);
    const vat = (0, billing_vouchers_1.billingVoucherSum)(depositShare.vat);
    return {
        deposit,
        vat,
        collectionCommission,
        payout,
        overpayment,
        balance: vat - payout,
    };
};
exports.getDepositShareSums = getDepositShareSums;
const bVFilter = (filter) => (billingVoucher) => {
    if (filter === null || filter === void 0 ? void 0 : filter.caseId) {
        return billingVoucher.caseId === filter.caseId;
    }
    return true;
};
const dSFilter = (filter) => (depositShare) => {
    if (filter === null || filter === void 0 ? void 0 : filter.caseId) {
        return depositShare.caseId === filter.caseId;
    }
    return true;
};
const getSums = (billing, filter) => {
    const disbursementsSum = billing.disbursements
        .filter(bVFilter(filter))
        .reduce((acc, voucher) => acc + voucher.amount, 0);
    const feesSum = billing.fees
        .filter(bVFilter(filter))
        .reduce((acc, voucher) => acc + voucher.amount, 0);
    const depositSum = billing.depositShare
        .filter(dSFilter(filter))
        .reduce((acc, depositShare) => {
        const { deposit } = (0, exports.getDepositShareSums)(depositShare);
        return deposit + acc;
    }, 0);
    const vatSum = billing.vat
        .filter(bVFilter(filter))
        .reduce((acc, voucher) => acc + voucher.amount, 0);
    const collectionCommissionSum = billing.depositShare
        .filter(dSFilter(filter))
        .reduce((acc, depositShare) => {
        const { collectionCommission } = (0, exports.getDepositShareSums)(depositShare);
        return collectionCommission + acc;
    }, 0);
    const collectionCommissionVatSum = billing.depositShare
        .filter(dSFilter(filter))
        .reduce((acc, { vat }) => acc + (0, billing_vouchers_1.billingVoucherSum)(vat), 0);
    const payoutSum = billing.depositShare
        .filter(dSFilter(filter))
        .reduce((acc, depositShare) => {
        const { payout } = (0, exports.getDepositShareSums)(depositShare);
        return payout + acc;
    }, 0);
    const overpaymentsSum = billing.depositShare
        .filter(dSFilter(filter))
        .reduce((acc, depositShare) => {
        const { overpayment } = (0, exports.getDepositShareSums)(depositShare);
        return overpayment + acc;
    }, 0);
    const disbursementsVatSum = getVatSum(billing.disbursements.filter(bVFilter(filter)));
    const feesVatSum = getVatSum(billing.fees.filter(bVFilter(filter)));
    const subTotal = -depositSum + collectionCommissionSum + feesSum + disbursementsSum;
    const vat = vatSum + disbursementsVatSum + feesVatSum + collectionCommissionVatSum;
    return {
        disbursementsSum,
        disbursementsVatSum,
        feesSum,
        feesVatSum,
        depositSum,
        vatSum,
        collectionCommissionSum,
        collectionCommissionVatSum,
        payoutSum,
        overpaymentsSum,
        vat,
        subTotal,
        balance: subTotal + vat,
    };
};
exports.getSums = getSums;
//# sourceMappingURL=organize.js.map